import { DefaultOptionType } from "antd/es/select"

export const enum FIELDS_TYPE {
  DATE = "date",
  INPUT = "input",
  SEARCH = "search",
  SELECT = "select",
}

export type FiltersFieldType = FiltersFieldBaseType | FiltersFieldSelectType

export type FiltersFieldBaseType = {
  col?: number
  isLoading?: boolean
  label?: string
  name: string
  placeholder?: string
  prepareValue?: (value: any) => any
  type: FIELDS_TYPE
}

export type FiltersFieldSelectType = {
  options: DefaultOptionType[]
} & FiltersFieldBaseType

export type TableFilterProps = {
  clearAll?: boolean
  fields: FiltersFieldType[]
  onChange: (values: any) => void
  state: any
}
